<template>
  <div class="bg-white p-4">
    <h6 class="font-weight-bold color-deeppink"><most-encouraging-icon :style="{fontSize:'2rem'}" /> <span class="ml-4">Most encouraging other</span></h6>
    <div class="p-3">
      <b-row align-v="center">
        <b-col cols="12" md class="mb-2 mb-sm-0">
          <div class="text-center">
            <avatar :src="user.photo" size="4.375rem" />
            <div class="mt-3 font-weight-bold">{{user.firstName}}</div>
          </div>
        </b-col>
        <b-col cols="12" md>
          <ul>
            <li v-for="option in achievements" :key="option">{{option}}</li>
          </ul>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/common/Avatar'
import MostEncouragingIcon from '@/assets/images/most-encouraging.svg'

export default {
  name: 'MostEncourage',

  props: {
    data: {
      type: Object,
      default: () => ({
        achievements: [],
        user: {}
      })
    }
  },

  computed: {
    user() {
      return (this.data || {}).user || {}
    },

    achievements() {
      return (this.data || {}).achievements || []
    }
  },

  components: {
    Avatar,
    MostEncouragingIcon
  }
}
</script>
